/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ParentGroup } from './ParentGroup';
import {
    ParentGroupFromJSON,
    ParentGroupFromJSONTyped,
    ParentGroupToJSON,
} from './ParentGroup';
import type { Status } from './Status';
import {
    StatusFromJSON,
    StatusFromJSONTyped,
    StatusToJSON,
} from './Status';
import type { StatusCodes } from './StatusCodes';
import {
    StatusCodesFromJSON,
    StatusCodesFromJSONTyped,
    StatusCodesToJSON,
} from './StatusCodes';

/**
 * 
 * @export
 * @interface ParentGroupResponse
 */
export interface ParentGroupResponse extends Status {
    /**
     * 
     * @type {ParentGroup}
     * @memberof ParentGroupResponse
     */
    group?: ParentGroup;
}

/**
 * Check if a given object implements the ParentGroupResponse interface.
 */
export function instanceOfParentGroupResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ParentGroupResponseFromJSON(json: any): ParentGroupResponse {
    return ParentGroupResponseFromJSONTyped(json, false);
}

export function ParentGroupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParentGroupResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...StatusFromJSONTyped(json, ignoreDiscriminator),
        'group': !exists(json, 'group') ? undefined : ParentGroupFromJSON(json['group']),
    };
}

export function ParentGroupResponseToJSON(value?: ParentGroupResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...StatusToJSON(value),
        'group': ParentGroupToJSON(value.group),
    };
}

